var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticStyle: { position: "relative", display: "inline-block" } },
    [
      _c("i", {
        staticClass: "el-icon-arrow-down el-icon-delete",
        staticStyle: {
          position: "absolute",
          top: "6px",
          right: "24px",
          color: "#878d9f",
          cursor: "pointer",
          "z-index": "1",
        },
        on: { click: _vm.removeItem },
      }),
      _c(
        "el-dropdown",
        {
          attrs: { trigger: "click", size: "mini" },
          on: { command: _vm.clickItem },
        },
        [
          _c(
            "span",
            { staticClass: "el-dropdown-link" },
            [
              _c(
                "el-tag",
                {
                  staticClass: "item-axis",
                  attrs: { size: "small", type: _vm.tagType },
                },
                [
                  _c(
                    "span",
                    { staticStyle: { float: "left" } },
                    [
                      _vm.item.deType === 0
                        ? _c("svg-icon", {
                            staticClass: "field-icon-text",
                            attrs: { "icon-class": "field_text" },
                          })
                        : _vm._e(),
                      _vm.item.deType === 1
                        ? _c("svg-icon", {
                            staticClass: "field-icon-time",
                            attrs: { "icon-class": "field_time" },
                          })
                        : _vm._e(),
                      _vm.item.deType === 2 || _vm.item.deType === 3
                        ? _c("svg-icon", {
                            staticClass: "field-icon-value",
                            attrs: { "icon-class": "field_value" },
                          })
                        : _vm._e(),
                      _vm.item.deType === 5
                        ? _c("svg-icon", {
                            staticClass: "field-icon-location",
                            attrs: { "icon-class": "field_location" },
                          })
                        : _vm._e(),
                      _vm.item.sort === "asc"
                        ? _c("svg-icon", {
                            attrs: {
                              "icon-class": "sort-asc",
                              "class-name": "field-icon-sort",
                            },
                          })
                        : _vm._e(),
                      _vm.item.sort === "desc"
                        ? _c("svg-icon", {
                            attrs: {
                              "icon-class": "sort-desc",
                              "class-name": "field-icon-sort",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "item-span-style",
                      attrs: { title: _vm.item.name },
                    },
                    [_vm._v(_vm._s(_vm.item.name))]
                  ),
                  _vm.tagType === "danger" ? _c("field-error-tips") : _vm._e(),
                  _c("i", {
                    staticClass: "el-icon-arrow-down el-icon--right",
                    staticStyle: {
                      position: "absolute",
                      top: "6px",
                      right: "10px",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        icon: "el-icon-delete",
                        command: _vm.beforeClickItem("remove"),
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("chart.delete")))])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }